import React, { useState } from 'react';
import { api } from '../services/apiService';
import constants from '../constants';
import "../styles/StartButton.css";

const StartButton = ({ cvText, setQuestions, goToNextStep }) => {
  const [loading, setLoading] = useState(false);

  const handleStartQuiz = async () => {
    setLoading(true);
    try {
      console.log('[DEBUG StartButton] CV Text:', !!cvText); // Vérifie si cvText existe
      console.log('[DEBUG StartButton] Payload:', {
        cv_text: cvText?.slice(0, 100) + '...',
        job_description: constants.JOB_DESCRIPTION
      });

      if (!cvText) {
        throw new Error('Le texte du CV est manquant');
      }

      const payload = {
        cv_text: cvText,
        job_description: constants.JOB_DESCRIPTION
      };
      
      console.log('[DEBUG StartButton] Avant appel API');
      const result = await api.post('/questions/generate', payload);
      console.log('[DEBUG StartButton] Après appel API:', result);
      
      if (!result.questions || !Array.isArray(result.questions)) {
        throw new Error('Format de réponse invalide');
      }

      setQuestions(result.questions);
      goToNextStep('questions');
    } catch (error) {
      console.error('Erreur complète:', error);
      if (error.response) {
        console.log('Status:', error.response.status);
        console.log('Headers:', error.response.headers);
        console.log('Data:', error.response.data);
      }
      alert('Une erreur s\'est produite lors de la récupération des questions. Veuillez réessayer.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="start-quiz-container">
      <div className="quiz-intro">
        <h2>Évaluation des Compétences</h2>
        <p>
          Bienvenue dans notre processus d'évaluation interactif pour le poste de Conseiller(e) de Vente chez Leroy Merlin.
          Ce questionnaire a été personnalisé en fonction de votre CV pour évaluer au mieux vos compétences et votre adéquation avec notre culture d'entreprise.
        </p>
        <div className="quiz-features">
          <div className="feature-item">
            ⏱️ <span>5-10 minutes</span>
          </div>
          <div className="feature-item">
            📝 <span>Questions adaptatives</span>
          </div>
          <div className="feature-item">
            🎯 <span>Feedback détaillé</span>
          </div>
        </div>
        <p>
          Prenez votre temps pour répondre aux questions. Il n'y a pas de "bonnes" ou "mauvaises" réponses,
          nous cherchons à mieux vous connaître pour assurer la meilleure adéquation possible avec le poste.
        </p>
      </div>
      
      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
          <p className="loading-message">Personnalisation de vos questions...</p>
        </div>
      ) : (
        <button onClick={handleStartQuiz} className="start-quiz-button">
          Lancer le questionnaire
        </button>
      )}
    </div>
  );
};

export default StartButton;